import { render, staticRenderFns } from "./PushNotificationBlockedByBrowser.vue?vue&type=template&id=27d20d4f&"
import script from "./PushNotificationBlockedByBrowser.vue?vue&type=script&lang=js&"
export * from "./PushNotificationBlockedByBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports